module.exports = __webpack_public_path__ + "media/images/weather/313_day-f36e32be37449d02e1b23c917b65b4aa.png";